import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'metersToMiles'})
export class MetersToMilesPipe implements PipeTransform {
  transform(value: number): number {
    return value / 1609
  }
}